import { styledTheme } from 'heliocor-ui'

export const selectStyle = {
    control: (base) => ({
        ...base,
        boxShadow: "none",
        borderRadius: 3,
        minHeight: '32px',
        minWidth: '180px',
        border: `1px solid ${styledTheme.colors.grey500}`,
        fontSize: 14,
        '&:hover': { borderColor: styledTheme.colors.main400 },
        backgroundColor: 'white'
    }),
    placeholder: base => ({...base, color: '#a09e9e'}),
    dropdownIndicator: base => ({
        ...base,
        padding: 4
    }),
    clearIndicator: base => ({
        ...base,
        padding: 4
    }),
    multiValue: base => ({
        ...base,
        maxWidth: '160px',
        backgroundColor: styledTheme.colors.main400
    }),
    valueContainer: base => ({
        ...base,
        padding: '0px 6px'
    }),
    input: base => ({
        ...base,
        margin: 0,
        padding: 0
    }),
    option: (base, state) => ({
        ...base,
        boxShadow: "none",
        paddingLeft: 6,
        borderRadius: 0,
        fontSize: 14,
        backgroundColor: 
        state.isSelected
            ? styledTheme.colors.main
            : state.isFocused
                ? styledTheme.colors.main400
                : null,
        '&:hover': { backgroundColor: styledTheme.colors.main400 }
    }),
    menu: base => ({
        ...base,
        borderRadius: 0,
        marginTop: 0,
        marginBottom: 0,
        minWidth: 150,
        overflowY: 'hidden',
        position: 'absolute',
        paddingBottom: 0,
        paddingTop: 0
    }),
    menuList: base => ({
        maxHeight: '170px',
        overflow: 'auto'
    }),
    color: base => ({
        ...base,
        text: 'blue'
    })
  }
  